export default __webpack_public_path__ + "static/media/d7a96822a116dfe96cbfe39dd6679eb2.svg";